// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"b0801bff","497":"5db0ae41","568":"cb02d7a0","963":"d719b153"}[chunkId] + ".chunk.js";
};